import { useHasScheduledJobPhasesMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useHasScheduledJobPhases() {
  const [mutation, { loading, data, error }] = useHasScheduledJobPhasesMutation();
  const [hasScheduledJobPhases, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "hasScheduledJobPhases",
    },
    {
      hideMessage: true,
    }
  );

  return [hasScheduledJobPhases, context] as const;
}
